import { useEffect, useState } from 'react';
import bugsnagClient from '../core/bugsnag';

export const useQueryParams = (): URLSearchParams | undefined => {
  const [params, setParams] = useState<URLSearchParams | undefined>(undefined);
  useEffect(() => {
    try {
      setParams(new URLSearchParams(window.location.search));
    } catch (e) {
      bugsnagClient.notify(e, {
        metaData: {
          search: window?.location?.search,
        },
      });
      setParams(undefined);
    }
  }, []);

  return params;
};

export default useQueryParams;
